module.exports = "/img/_/_/_/assets/images/creeper/book/rare//4.jpg?a55f84645aee4957e06357f2d23d1b32";